import styled from "styled-components"


export const BreakpointsPage = () => {
  return (
    <StyleWrap>
      BreakpointsPage
    </StyleWrap>
  )
}

const StyleWrap = styled.div`

`;